import { Component, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../service/auth-service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, MatSnackBarModule, RouterLink],
  templateUrl: './forgot-password.html',
  styleUrl: './forgot-password.scss'
})
export class ForgotPassword {
  protected loading = false;
  protected forgotPasswordForm: FormGroup
  private authService = inject(AuthService)
  private snackBar = inject(MatSnackBar)

  constructor() {
    this.forgotPasswordForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  onSubmit() {
    if (this.forgotPasswordForm.invalid) return;

    this.loading = true;
    const email = this.forgotPasswordForm.value.email!;

    this.authService.resetPassword(email)
      .then(() => {
        this.snackBar.open('Password reset email sent! Check your inbox.', 'Close', { duration: 5000 });
      })
      .catch((err) => {
        this.snackBar.open("Error resetting password", 'Close', { duration: 5000 });
        console.log(err)
      }).finally(() => {
        this.loading = false
      });
  }
}
